export function LifegridMark({ size = 28, className = "" }) {
  // Minimal grid+cross: 4 nodes at corners, connected through a central cross.
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="4" stroke="rgba(204,255,0,0.35)" />
      <path d="M16 4 V28" stroke="#CCFF00" strokeWidth="1.6" />
      <path d="M4 16 H28" stroke="#CCFF00" strokeWidth="1.6" />
      <circle cx="4" cy="4" r="2" fill="#CCFF00" />
      <circle cx="28" cy="4" r="2" fill="#00E5FF" />
      <circle cx="4" cy="28" r="2" fill="#00E5FF" />
      <circle cx="28" cy="28" r="2" fill="#CCFF00" />
      <circle cx="16" cy="16" r="2.4" fill="#F8FAFC" />
    </svg>
  );
}

export function LifegridWordmark({ subtitle = null }) {
  return (
    <div className="flex items-center gap-3">
      <LifegridMark size={30} />
      <div className="flex flex-col leading-none">
        <span className="font-display font-extrabold tracking-[0.22em] text-[15px]">LIFEGRID</span>
        {subtitle && <span className="font-mono-tac text-[10px] text-[color:var(--lg-text-3)] mt-1">{subtitle}</span>}
      </div>
    </div>
  );
}
